module.exports = __webpack_public_path__ + "static/media/not_found.e94e99be.svg";